
































































import Vue from 'vue';
import ChooseSettings from './components/ChooseSettings.vue';
import Scouting from './components/Scouting.vue';
import MissionNotches from './components/MissionNotches.vue';
import Heroes from './components/Heroes.vue';
import Downtime from './components/Downtime.vue';
import Battling from './components/Battling.vue';
import Upgrades from './components/Upgrades.vue';

// eslint-disable-next-line no-unused-vars
import {Run} from "@/types/run";
// eslint-disable-next-line no-unused-vars
import {Game} from "@/types/game";
// eslint-disable-next-line no-unused-vars
import {Upgrade} from "@/types/upgrade";
import {mapGetters, mapState} from "vuex";
import Upgrading from "@/components/Upgrading.vue";

type GameSlot = {
  game: null | Game
  number: number
}

export default Vue.extend({
  name: 'App',
  computed: {
    ...mapState({
      phase: 'phase',
      upgradeOptions: 'upgradeOptions',
      players: 'players',
      activeGameIndex: 'activeGameIndex',
      games: 'games',
     }),
    ...mapGetters({
      gameSlots: 'gameSlots',
      activeGame: 'activeGame'
    }),
  },
  data () {
    return {
      tab: 'play',
      devMode: window.location.hash.indexOf('dev') >= 0
    }
  },
  components: {
    ChooseSettings,
    MissionNotches,
    Heroes,
    Downtime,
    Battling,
    Scouting,
    Upgrading,
    Upgrades,
  },
  watch: {
    phase () {
      window.scrollTo(0, 0)
    }
  },
  methods:  {
    setTab (tab: string) {
      this.tab = tab
      Vue.nextTick(() => {
        console.log('scroll to', )
        window.scrollTo(0, 0)
      })
    },
  }
});
